import axios from 'axios'

const accountingSeatPrintPDF = async function(id) {
    try{
        const path = `/acc_accounting_seat/${id}/pdf`,
            route = process.env.VUE_APP_API_ROUTE.concat(path)
        let response = await axios({
            url: route,
            method: 'GET',
            responseType: 'blob',
        })
        return response
    }
    catch(error) {
        return error.response
    }
    
}
export { accountingSeatPrintPDF }
